export default "__VITE_ASSET__ByTdiibz__"